import { IBannerInlinePlaceholderProps } from '@tekface/smart-activation';
import { ProductDetailProvider, useTenantConfig } from 'contexts';
import { getServerSidePropsDetail } from 'modules/product-detail/shared';
import dynamic from 'next/dynamic';
import React from 'react';
import { ProductResponse } from 'types';

const NewDetailPage = dynamic(() =>
  import('modules/product-detail/desktop').then((mod) => mod.NewDetailPage),
);

const DetailPage = dynamic(() =>
  import('modules/product-detail/desktop').then((mod) => mod.DetailPage),
);

export interface ProductDetailsProps {
  serverProduct: ProductResponse;
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
}

const ProductDetailsPage: React.FunctionComponent<ProductDetailsProps> = ({
  serverProduct,
  inlineBanners,
}: ProductDetailsProps) => {
  const { epicOmni1643 } = useTenantConfig();

  return (
    <ProductDetailProvider
      serverProduct={serverProduct}
      inlineBanners={inlineBanners}
    >
      {epicOmni1643 ? <NewDetailPage /> : <DetailPage />}
    </ProductDetailProvider>
  );
};

export const getServerSideProps = getServerSidePropsDetail;

export default ProductDetailsPage;
